
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/first-post",
      function () {
        return require("private-next-pages/blog/first-post/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/first-post"])
      });
    }
  